export const isCurrentUser = (userId) =>
  // eslint-disable-next-line no-underscore-dangle
  window.DashboardComponent._userSession._userEntity.id === userId;
